import { render, staticRenderFns } from "./FormLesson.vue?vue&type=template&id=31f2cdb0&"
import script from "./FormLesson.vue?vue&type=script&lang=js&"
export * from "./FormLesson.vue?vue&type=script&lang=js&"
import style0 from "./FormLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports